import { format } from 'date-fns'
import { schema } from 'normalizr'
import { createEntitySchemas } from '../../../utils/normalize'

const formatDate = dateStr => dateStr ? format(new Date(dateStr), 'dd/MM/yyyy') : dateStr

const processBankingPoolDate = entity => ({
  ...entity,
  expiration: formatDate(entity.expiration)
})

export const FINANCIAL_BANKING_POOL = 'financialBankingPools'
export const financialBankingPoolSchema = new schema.Entity(FINANCIAL_BANKING_POOL, {}, {
  processStrategy: processBankingPoolDate
})

export const FINANCIAL = 'financial'
export const financialSchemas = createEntitySchemas(FINANCIAL, {
  definitions: {
    banking_pool: [financialBankingPoolSchema]
  },
  options: {
    processStrategy: (entity) => ({
      ...entity,
      capital_invested: Number(entity.capital_invested),
      annual_average_income: Number(entity.annual_average_income)
    })
  }
})
